import { render, staticRenderFns } from "./ProfileHabilityList.vue?vue&type=template&id=f391332c"
import script from "./ProfileHabilityList.vue?vue&type=script&lang=js"
export * from "./ProfileHabilityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports